'use client';

import { c as _c } from "react/compiler-runtime";
import { BuilderBlocks } from '@builder.io/react';
import { type NutritionalFactsItem } from '@src/components/NutritionalFacts/NutritionalFacts.props';
import { cn } from '@src/utils/tailwind';
export interface NutritionalFactsContentProps {
  nutritionalInfo: NutritionalFactsItem;
  singleColumn?: boolean;
  builderBlock?: any;
}
export const NutritionalFactsContent = props => {
  const $ = _c(32);
  const {
    nutritionalInfo,
    builderBlock,
    singleColumn
  } = props;
  let t0;
  if ($[0] !== nutritionalInfo) {
    t0 = nutritionalInfo ?? {};
    $[0] = nutritionalInfo;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    tableItems,
    flavorName,
    blocksRight,
    blocksTop,
    blocksBottom
  } = t0;
  let t1;
  if ($[2] !== builderBlock?.id || $[3] !== flavorName || $[4] !== tableItems) {
    t1 = () => <div className="flex flex-col">{tableItems?.map((item, i) => {
        const isHeader = item.cellType === "header";
        const isBody = item.cellType === "body";
        return <div key={`${flavorName}-${i}`} className={cn("flex gap-4", {
          "border-b-[6px] border-bodi-black-text text-bodi-accent-deep-500 pt-2": isHeader,
          "border-b border-bodi-gray-butters text-bodi-black-text py-1": isBody
        })}><div className="flex-1 font-medium"><BuilderBlocks key={`${flavorName}-${i}-content`} parentElementId={builderBlock?.id} dataPath={`component.options.item.${flavorName}.${i}.content`} blocks={item.content} /></div><div className="flex gap-4">{item.columns.map((column, j) => <BuilderBlocks key={`${flavorName}-${i}-${j}`} parentElementId={builderBlock?.id} dataPath={`component.options.column.${flavorName}.${i}.${j}.content`} blocks={column.content} style={{
              minWidth: "28px"
            }} />)}</div></div>;
      })}</div>;
    $[2] = builderBlock?.id;
    $[3] = flavorName;
    $[4] = tableItems;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const renderTable = t1;
  const t2 = !singleColumn;
  let t3;
  if ($[6] !== singleColumn || $[7] !== t2) {
    t3 = cn("relative flex flex-col gap-10 *:flex-1", {
      "lg:flex-col": singleColumn,
      "lg:flex-row": t2
    });
    $[6] = singleColumn;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = builderBlock?.id;
  const t5 = `component.options.${flavorName}.top.content`;
  let t6;
  if ($[9] !== blocksTop || $[10] !== t4 || $[11] !== t5) {
    t6 = <BuilderBlocks parentElementId={t4} dataPath={t5} blocks={blocksTop} />;
    $[9] = blocksTop;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== renderTable) {
    t7 = renderTable();
    $[13] = renderTable;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const t8 = builderBlock?.id;
  const t9 = `component.options.${flavorName}.bottom.content`;
  let t10;
  if ($[15] !== blocksBottom || $[16] !== t8 || $[17] !== t9) {
    t10 = <BuilderBlocks parentElementId={t8} dataPath={t9} blocks={blocksBottom} />;
    $[15] = blocksBottom;
    $[16] = t8;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t6 || $[21] !== t7) {
    t11 = <div className="flex flex-col">{t6}{t7}{t10}</div>;
    $[19] = t10;
    $[20] = t6;
    $[21] = t7;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== blocksRight || $[24] !== builderBlock?.id || $[25] !== flavorName || $[26] !== singleColumn) {
    t12 = !singleColumn && <BuilderBlocks parentElementId={builderBlock?.id} dataPath={`component.options.${flavorName}.right.content`} blocks={blocksRight} />;
    $[23] = blocksRight;
    $[24] = builderBlock?.id;
    $[25] = flavorName;
    $[26] = singleColumn;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t11 || $[29] !== t12 || $[30] !== t3) {
    t13 = <div className={t3}>{t11}{t12}</div>;
    $[28] = t11;
    $[29] = t12;
    $[30] = t3;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  return t13;
};